import { injectable } from "inversify";
import { IConnectOptions, IWebSocketClient } from "./IWebSocketClient";
import {
  HubConnection,
  HubConnectionBuilder,
  HubConnectionState
} from "@microsoft/signalr";
import useStorage from "@/core/plugins/useStorage";
import { LocalStorageKeys } from "@/core/@types/types";

@injectable()
export default class WebSocketClient implements IWebSocketClient {
  private _connection!: HubConnection;

  constructor() {}

  get connection(): HubConnection {
    return this._connection;
  }

  async connect(options: IConnectOptions) {
    const storage = useStorage();

    const port = import.meta.env.VITE_APP_WEBSOCKET_URL;
    const url = `${port}/${options.url}`;

    this._connection = new HubConnectionBuilder()
      .withUrl(url, {
        accessTokenFactory: () => {
          return storage.get(LocalStorageKeys.Token) || "";
        },
        ...options
      })
      .withAutomaticReconnect()
      .build();

    try {
      await this._connection.start();
    } catch (err) {
      console.error("Erro ao conectar ao SignalR:", err);
    }
  }

  async disconnect(): Promise<void> {
    if (this._connection?.state === HubConnectionState.Connected) {
      await this._connection.stop();
    }
  }

  on<T>(event: string, callback: (data: T) => void): void {
    this._connection.on(event, callback);
  }

  off(event: string): void {
    this._connection.off(event);
  }

  async send<T = void>(method: string, ...args: unknown[]): Promise<T> {
    if (!this._connection) {
      throw new Error("Conexão não iniciada.");
    }

    return this._connection.invoke<T>(method, ...args);
  }
}
